import {
  FlowDurationUnits,
  FlowExportMode,
  type FlowFormV2Block,
  FlowFormV2BlockSchema,
  FlowFormV2Mode,
} from 'flow-schema';

import { FormV2BlockFormFields } from './FormFields';
import { formV2BlockDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';
import { getDefaultSchedulingConfigs } from '../Form/SchedulingConfigs/utils';

export const formV2Config: BlockConfigProps<FlowFormV2Block['config']> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'form',
  defaultConfig: {
    formTemplateConfigs: [],
    schedulingConfigs: getDefaultSchedulingConfigs(),
    isOverridingEntity: false,
    exportMode: FlowExportMode.RunAutoExport,
    mode: FlowFormV2Mode.AddAndWaitForCompletion,
    timeout: {
      value: 1,
      units: FlowDurationUnits.Days,
    },
    notificationSchemeIdOverride: null,
  },
  configFields: {
    schema: FlowFormV2BlockSchema.shape.config,
    FormFields: FormV2BlockFormFields,
  },
  documentationMarkdown: formV2BlockDocumentationMarkdown,
};
